module.exports = __webpack_public_path__ + "static/media/Raze_(Full).5945ece6.png";